import React from 'react';
import './RadiatorCovers.css';
import GalleryTemplate from "../gallery template/GalleryTemplate";

class RadiatorCovers extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page'}>
                <div className={'radiator_covers'}>
                    <h1 className={'pageTitle'}>Stylish & Functional Radiator Covers</h1>
                    <p className={'pageDescription'}>Elevate your interiors while concealing unsightly radiators with our custom-made radiator covers. Crafted with precision, our designs not only enhance the aesthetics of your room with elegant grilles and finishes but also provide a practical display surface, blending seamlessly into your home's decor.</p>
                    <GalleryTemplate
                        title={'Contemporary Grey Horizontal Slatted Radiator Cover'}
                        description={' A sleek and modern custom radiator cover in a contemporary grey finish, designed with horizontal slats to seamlessly blend with your interior while providing a functional surface.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Radiator Covers/1/20200624_125030_1.jpg',
                            '/gallery/Radiator Covers/1/20200615_124903_1.jpg',
                            '/gallery/Radiator Covers/1/20200624_125048_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Classic White Radiator Cover with Solid Wood Top'}
                        description={'This charming white radiator cover, featuring traditional vertical slats, is topped with a beautiful solid wood surface, adding a touch of natural warmth and a convenient display area.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Radiator Covers/2/20200624_124805_1.jpg',
                            '/gallery/Radiator Covers/2/20200615_124755_1.jpg',
                            '/gallery/Radiator Covers/2/20200624_124917_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Expansive White Radiator Cover with Multiple Panels'}
                        description={'Our large, custom-made white radiator cover features a multi-panel design with vertical slats, providing a substantial display surface and effectively concealing your radiator for a clean aesthetic.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Radiator Covers/3/IMG-20200624-WA0000.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Elegant White Radiator Cover with Slatted Design'}
                        description={'Enhance your living space with our custom-built white radiator cover, featuring a stylish slatted front and a practical top shelf perfect for displaying your favourite decor.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Radiator Covers/3/IMG-20200624-WA0001.jpg'
                        ]}/>
                </div>
            </div>
        );
    }
}

export default RadiatorCovers;
